import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/"; // Corrected API_URL for direct image access
const API_URL_API = "https://sunrise-backend.sunrisemeditechsystems.com/api"; // For API endpoints

// Custom CSS for Add to Cart button hover
// Place this at the top of your component for clarity
// You can also move it to your main CSS file if you prefer
const customWishlistBtnStyle = `
  .wishlist-add-cart-btn:hover {
    background: #222 !important;
    color: #fff !important;
    border: 1px solid #222 !important;
  }
`;

export default function WishList() {
  const navigate = useNavigate()
  const [wishlistItems, setWishlistItems] = useState([]);

  useEffect(() => {
    loadWishlistItems();
  }, []);

  const loadWishlistItems = () => {
    const userId = localStorage.getItem("currentUserId");
    const wishlistKey = `wishlist_${userId}`;
    const storedWishlist = JSON.parse(localStorage.getItem(wishlistKey) || "[]").map(item => ({
      ...item,
      quantity: item.quantity || 1,
      type: item.type || 'buy',
    }));
    setWishlistItems(storedWishlist);
  };

  const handleRemoveFromWishlist = (productId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!"
    }).then((result) => {
      if (result.isConfirmed) {
        const userId = localStorage.getItem("currentUserId");
        const wishlistKey = `wishlist_${userId}`;
        const updatedWishlist = wishlistItems.filter(item => item.productId !== productId);
        localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
        setWishlistItems(updatedWishlist); // Update state to re-render
        Swal.fire("Removed!", "Your product has been removed from wishlist.", "success");
      }
    });
  };

  const handleAddToCartFromWishlist = async (item) => {
    // Fetch latest stock
    try {
      const res = await axios.get(`${API_URL_API}/products/${item.productId}`);
      const product = res.data;
      const isBuy = !item.type || item.type === 'buy';
      const isRent = item.type === 'rent';
      if (isBuy && product.saleStock <= 0) {
        Swal.fire('Out of Stock', 'This product is out of stock for purchase.', 'error');
        return;
      }
      if (isRent && (!product.isRentalAvailable || product.rentalStock <= 0)) {
        Swal.fire('Out of Stock', 'This product is out of stock for rent.', 'error');
        return;
      }
    } catch (err) {
      Swal.fire('Error', 'Could not check product stock.', 'error');
      return;
    }
    const cartItem = {
      productId: item.productId,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      type: item.type,
      image: item.image,
    };

    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    const existingCart = JSON.parse(localStorage.getItem(cartKey) || "[]");
    const existingItemIndex = existingCart.findIndex(
      (cartItm) => cartItm.productId === cartItem.productId && cartItm.type === cartItem.type
    );

    if (existingItemIndex > -1) {
      Swal.fire({
        title: "Product already in cart",
        text: "This product is already in your cart. Do you want to remove it from your wishlist?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove from wishlist!",
        cancelButtonText: "No, keep in wishlist"
      }).then((result) => {
        if (result.isConfirmed) {
          existingCart[existingItemIndex].quantity += cartItem.quantity;
          localStorage.setItem(cartKey, JSON.stringify(existingCart));
          const updatedWishlist = wishlistItems.filter(wishlistItem => wishlistItem.productId !== item.productId);
          const wishlistKey = `wishlist_${userId}`;
          localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
          setWishlistItems(updatedWishlist); // Update state to re-render
          localStorage.setItem(cartKey, JSON.stringify(existingCart));
          localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
          window.dispatchEvent(new Event('cartUpdated'));         
          Swal.fire("Added!", `${item.name} quantity updated in cart and removed from wishlist.`, "success");
        } else {
          Swal.fire("Kept!", `${item.name} remains in your wishlist.`, "info");
        }
      });
    } else {
      existingCart.push(cartItem);
      localStorage.setItem(cartKey, JSON.stringify(existingCart));
      const updatedWishlist = wishlistItems.filter(wishlistItem => wishlistItem.productId !== item.productId);
      const wishlistKey = `wishlist_${userId}`;
      localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
      setWishlistItems(updatedWishlist); // Update state to re-render
      localStorage.setItem(cartKey, JSON.stringify(existingCart));
      localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
      window.dispatchEvent(new Event('cartUpdated'));
      Swal.fire({
        title: "Added to Cart!",
        text: `${item.name} has been moved to your cart.`,
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    }
     navigate("/cart");
  };
 const goHome = () => {
 window.location.href ="https://sunrisemeditechsystems.com";
};
  return (
    <>
      {/* Custom CSS for Add to Cart button hover */}
      <style>{customWishlistBtnStyle}</style>
  {/* BREADCRUMB AREA START */}
  <div
    className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
    data-bs-bg="img/bg/sunrise-medical.jpg"
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="ltn__breadcrumb-inner">
            <h1 className="page-title">Wishlist</h1>
            <div className="ltn__breadcrumb-list">
              <ul>
                <li className='bg-black-color'>
                 <Link
                        to="#"
                        onClick={goHome}
                        className="bg-black-color"
                        style={{ cursor: "pointer" }}
                      >
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home bg-black-color" />
                        </span>{" "}
                        Home
                      </Link>
                </li>
                <li>Wishlist</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* BREADCRUMB AREA END */}
  {/* WISHLIST AREA START */}
  <div className="liton__wishlist-area mb-105">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="shoping-cart-inner">
            <div className="shoping-cart-table table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead>
                  <tr>
                    <th className="cart-product-remove" style={{ width: '60px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>#</th>
                    <th className="cart-product-image" style={{ width: '100px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Image</th>
                    <th className="cart-product-info" style={{ width: '100px',textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Product</th>
                    <th className="cart-product-price" style={{ width: '100px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Price</th>
                    <th className="cart-product-quantity" style={{ width: '120px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Quantity/Days</th>
                    <th className="cart-product-subtotal" style={{ width: '80px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Type</th>
                    <th className="cart-product-add-cart" style={{ width: '150px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {wishlistItems.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center" style={{ verticalAlign: 'middle', padding: '15px 5px' }}>
                        Your wishlist is empty.
                      </td>
                    </tr>
                  ) : (
                    wishlistItems.map((item) => (
                      <tr key={item.productId}>
                        <td className="cart-product-remove" style={{ width: '60px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>
                          <button onClick={() => handleRemoveFromWishlist(item.productId)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'red', fontSize: '1.2em' }}>
                            <i className="fa fa-times"></i>
                          </button>
                        </td>
                        <td className="cart-product-image" style={{ width: '100px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>
                          <Link to={`/product/${item.productId}`}>
                            <img src={`${API_URL}${item.image}`} alt={item.name} style={{ width: '80px', height: 'auto' }} />
                          </Link>
                        </td>
                        <td className="cart-product-info" style={{width: '100px', textAlign: 'left', verticalAlign: 'middle', padding: '15px 5px' }}>
                          <h4>
                            <Link to={`/product/${item.productId}`}>{item.name}</Link>
                          </h4>
                        </td>
                            <td className="cart-product-price" style={{ width: '100px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>₹{item.price.toFixed(2)}</td>
                        <td className="cart-product-quantity" style={{ width: '120px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>
                          {item.quantity || 'N/A'} {item.type === 'rent' ? 'days' : ''}
                        </td>
                        <td className="cart-product-subtotal" style={{ width: '80px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>
                          {item.type || 'N/A'}
                        </td>
                        <td className="cart-product-add-cart" style={{ width: '150px', textAlign: 'center', verticalAlign: 'middle', padding: '15px 5px' }}>
                          <button
                                className="submit-button-1 theme-btn-1 btn-effect-1 wishlist-add-cart-btn"
                                style={{ minWidth: '80px', height: '32px', fontSize: '0.95em', padding: '4px 10px' }}
                            onClick={() => handleAddToCartFromWishlist(item)}
                          >
                            Add to Cart
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* WISHLIST AREA END */}
</>
  );
}